// src/pages/PrescriptionsPage.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import TemplatesManager from '../components/prescriptions/TemplatesManager';
import DocumentsManager from '../components/prescriptions/DocumentsManager';
import BrandingForm from '../components/prescriptions/BrandingForm';

export default function PrescriptionsPage() {
  const { user } = useAuth();
  const canManageTemplates = (user?.permissions || []).includes('documents.manage_templates');
  const [activeTab, setActiveTab] = useState('documents');

  return (
    <Layout title="Documentos Clínicos">
      <div className="p-4">
        {/* Tabs */}
        <div className="flex items-center gap-2 mb-4">
          {(canManageTemplates ? ['documents', 'templates', 'branding'] : ['documents']).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 rounded-md border ${activeTab === tab ? 'bg-purple-600 text-white' : 'bg-white'}`}
            >
              {tab === 'documents' && 'Documentos'}
              {tab === 'templates' && 'Templates'}
              {tab === 'branding' && 'Visual'}
            </button>
          ))}
        </div>

        {canManageTemplates && activeTab === 'templates' && <TemplatesManager />}
        {activeTab === 'documents' && <DocumentsManager />}
        {canManageTemplates && activeTab === 'branding' && <BrandingForm />}
      </div>
    </Layout>
  );
}
